import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function Avatar({ fields, scope }: ComponentProps) {
  const url = useBound<string>(fields.imageUrl as BoundValue, scope);
  const initials = useBound<string>(fields.initials as BoundValue, scope);
  const size = useBound<string>(fields.size as BoundValue, scope) ?? "md";

  return (
    <span className={`a2-avatar size-${size}`}>
      {url
        ? <img src={url} alt="" />
        : <span className="a2-avatar-initials">{(initials ?? "?").slice(0, 2)}</span>}
    </span>
  );
}
